import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  container: {
    display: "inline-flex",
    alignItems: "center",
    gap: 8, // spacing between icon and text
    lineHeight: 1,
    color: "#fefefe", // single source of truth for both icon and text color
  },
  svg: {
    width: "auto",
    height: 30, // same size as your original LogoFull
    display: "block",
  },
  path: {
    fill: "currentColor", // makes all shapes adopt the container text color
  },
  text: {
    fontSize: 20, // adjust to match visual weight of your wordmark
    fontWeight: 600, // optional: tweak per brand guidelines
    letterSpacing: 0.2,
  },
});

const LogoFull = () => {
  const classes = useStyles();

  return (
    <span className={classes.container} aria-label="TechDocs logo">
      <svg
        className={classes.svg}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 315.8 179.9"
      >
        <path
          className={classes.path}
          d="M108,117.4v-17.9h11.3v2.7h-8.5v4.7h7.1v2.7h-7.1v5.2h8.5v2.6h-11.3Z"
        />
        <path
          className={classes.path}
          d="M123,117.4v-13.4h2.6v2.1c.5-.7,1.1-1.3,1.9-1.7.8-.4,1.6-.7,2.5-.7,3.1,0,4.6,1.8,4.6,5.5v8.2h-2.6v-8c0-2.3-1-3.4-2.8-3.3-.6,0-1.2,0-1.8.4-.5.3-.9.7-1.3,1.1-.3.5-.5,1-.5,1.6v8.1h-2.6Z"
        />
        <path
          className={classes.path}
          d="M144.2,123.2c-1,0-1.9-.2-2.9-.4-.8-.2-1.6-.6-2.3-1.2l1-2c.6.4,1.2.8,1.9,1s1.5.4,2.3.3c2.8,0,4.3-1.3,4.3-4v-1.7c-.3.5-.6.9-1.1,1.2-.5.4-1,.7-1.6.9-.6.2-1.2.3-1.8.3-2.4,0-4.6-1.3-5.8-3.4-.6-1.1-.9-2.3-.9-3.6s.3-2.5.9-3.6c.5-1,1.4-1.9,2.3-2.5,1-.6,2.2-.9,3.3-.9s1.8.2,2.6.6c.7.3,1.3.8,1.9,1.4v-1.8h2.6v12.6c.1,1.8-.6,3.6-1.8,4.9-1.2,1.4-3,2-4.9,1.9ZM144.3,115.2c.8,0,1.6-.2,2.2-.6.6-.4,1.2-.9,1.5-1.6.7-1.5.7-3.2,0-4.7-.3-.7-.9-1.2-1.5-1.6-.7-.4-1.4-.6-2.2-.6s-1.5.2-2.2.6c-.6.4-1.2,1-1.5,1.6-.7,1.5-.7,3.2,0,4.7.3.7.9,1.2,1.5,1.6.7.4,1.5.6,2.2.6h0Z"
        />
        <path className={classes.path} d="M154.8,117.4v-18.9h2.6v18.9h-2.6Z" />
        <path
          className={classes.path}
          d="M166.1,117.6c-1.1,0-2.1-.3-3-.9s-1.7-1.5-2.2-2.5c-1.1-2.3-1.1-4.9,0-7.2.5-1,1.3-1.9,2.2-2.5,1-.6,2.1-.9,3.2-.9s1.8.2,2.7.7c.7.4,1.3,1,1.8,1.7v-2h2.6v13.4h-2.6v-2.1c-.5.7-1.2,1.3-2,1.7-.8.4-1.8.6-2.7.6ZM166.8,115.2c.7,0,1.5-.2,2.1-.6s1.1-1,1.4-1.6c.4-.7.5-1.5.5-2.4s-.2-1.6-.5-2.3c-.3-.7-.8-1.2-1.4-1.6-.6-.4-1.4-.6-2.1-.6s-1.5.2-2.1.6-1.1,1-1.4,1.6c-.4.7-.5,1.5-.5,2.3s.2,1.6.5,2.4c.3.7.8,1.2,1.4,1.6.6.4,1.4.6,2.1.6Z"
        />
        <path
          className={classes.path}
          d="M177.1,117.4v-13.4h2.6v2.1c.5-.7,1.1-1.3,1.9-1.7s1.6-.7,2.5-.7c3.1,0,4.6,1.8,4.6,5.5v8.2h-2.6v-8c0-2.3-1-3.4-2.8-3.3-.6,0-1.2,0-1.8.4-.5.3-.9.6-1.3,1.1-.3.5-.5,1-.5,1.6v8.1h-2.6Z"
        />
        <path
          className={classes.path}
          d="M197.9,117.6c-1.2,0-2.3-.3-3.3-.9s-1.8-1.5-2.3-2.5c-.6-1.1-.9-2.3-.8-3.6,0-1.2.3-2.5.8-3.6.5-1,1.3-1.9,2.3-2.5s2.1-.9,3.2-.9,1.7.2,2.5.6c.7.3,1.4.8,1.9,1.4v-7.1h2.6v18.9h-2.6v-1.8c-.5.6-1.1,1.1-1.8,1.5-.8.3-1.6.5-2.5.5ZM198.2,115.4c.8,0,1.5-.2,2.1-.6s1.1-1,1.4-1.7c.4-.8.5-1.6.5-2.4s-.2-1.7-.5-2.4c-.3-.7-.8-1.3-1.4-1.7-1.3-.8-2.9-.8-4.2,0-.6.4-1.1,1-1.4,1.7-.4.8-.5,1.6-.5,2.4s.2,1.7.5,2.4c.3.7.8,1.3,1.4,1.7.7.4,1.4.6,2.1.6Z"
        />
        <path
          className={classes.path}
          d="M40.8,92.2c-3.8,0-7.4-1.4-10.2-4.1-1.3-1.3-2.3-2.8-3-4.5-.7-1.8-1.1-3.7-1.1-5.6s.4-3.8,1.1-5.5,1.7-3.2,3-4.5c1.3-1.3,2.9-2.3,4.6-3,1.8-.7,3.7-1.1,5.6-1.1s2.7.2,4.1.6c1.3.4,2.5.9,3.6,1.7,1,.7,1.9,1.5,2.7,2.5l-2.8,2.9c-2-2.1-4.7-3.3-7.6-3.4-5.4,0-9.8,4.2-9.9,9.6v.3c0,1.3.3,2.7.8,3.9.5,1.2,1.3,2.3,2.2,3.2.9.9,2,1.6,3.2,2.2,1.2.5,2.5.8,3.9.8s2.6-.3,3.8-.8c1.1-.5,2.1-1.2,2.8-2.1s1-1.9,1-3v-.2h-7.8v-4.2h12.2c0,.4,0,.8.2,1.2v1.1c0,2.2-.5,4.4-1.6,6.3-1.1,1.8-2.6,3.3-4.4,4.3-2.1.9-4.3,1.4-6.4,1.4Z"
        />
        <path
          className={classes.path}
          d="M66.4,92.2c-2,0-3.9-.4-5.7-1.4-1.6-.9-2.9-2.2-3.9-3.7-.9-1.6-1.4-3.5-1.4-5.4s.4-4,1.4-5.7c.9-1.6,2.2-2.9,3.7-3.9,1.7-1,3.5-1.4,5.5-1.4s3.4.5,4.8,1.3c1.4.9,2.6,2.1,3.4,3.5.8,1.6,1.2,3.4,1.1,5.1v1.7h-15.8c.2,1.7,1,3.3,2.3,4.4,1.4,1.1,3.2,1.7,4.9,1.6,1,0,1.9-.2,2.8-.5,1.1-.5,2-1.1,2.9-1.9l2,2.9c-1.1,1-2.3,1.8-3.7,2.3-1.3.8-2.8,1.1-4.3,1.1ZM66,74.4c-3.5,0-5.7,1.6-6.3,4.8h11.5v-.3c0-.8-.4-1.6-.9-2.3-.9-1.4-2.6-2.2-4.3-2.2Z"
        />
        <path
          className={classes.path}
          d="M78.9,91.8v-20.6h4v3.2c.8-1.1,1.7-2,2.9-2.6,1.2-.7,2.5-1,3.9-1,4.7,0,7.1,2.8,7.1,8.5v12.6h-4.1v-12.4c0-3.6-1.4-5.2-4.4-5.1-1,0-1.9.2-2.8.7-.8.4-1.5,1-2,1.8-.5.7-.7,1.6-.7,2.5v12.5h-3.9Z"
        />
        <path
          className={classes.path}
          d="M110.8,92.2c-1.9,0-3.8-.4-5.4-1.4-1.6-.9-2.9-2.2-3.8-3.8-1.8-3.5-1.8-7.6,0-11.1.9-1.6,2.2-2.9,3.8-3.8,3.4-1.9,7.4-1.9,10.8,0,1.6.9,2.9,2.2,3.8,3.8,1.8,3.5,1.8,7.6,0,11.1-.9,1.6-2.2,2.9-3.8,3.8-1.7,1-3.6,1.5-5.4,1.4ZM110.8,88.5c1.2,0,2.3-.3,3.3-.9s1.8-1.5,2.3-2.5c.6-1.1.8-2.4.8-3.6s-.2-2.5-.8-3.6c-.5-1-1.3-1.9-2.3-2.5-2-1.2-4.6-1.2-6.6,0s-1.8,1.5-2.3,2.5c-.6,1.1-.8,2.4-.8,3.6s.2,2.5.8,3.6c.5,1,1.4,1.9,2.4,2.5.9.6,2,.9,3.2.9Z"
        />
        <path
          className={classes.path}
          d="M124.7,91.8v-20.6h4.1v3.3c.7-1.1,1.6-1.9,2.8-2.6,1.1-.7,2.4-1.1,3.7-1.1,3.2,0,5.3,1.4,6.3,4.3.4-.8,1-1.6,1.8-2.2s1.6-1.2,2.6-1.6c.9-.4,1.8-.6,2.8-.6,4.6,0,6.9,2.9,6.9,8.6v12.4h-4.1v-12c.1-1.4-.3-2.8-1.1-3.9-.8-.9-1.9-1.3-3.1-1.2-1.4,0-2.7.5-3.7,1.4s-1.5,2.2-1.5,3.5v12.4h-4.1v-12.3c.1-1.3-.2-2.6-1-3.7-.7-.9-1.9-1.4-3-1.3-.9,0-1.8.2-2.6.7-.8.4-1.4,1-1.9,1.7s-.7,1.6-.7,2.5v12.4h-4.2Z"
        />
        <path
          className={classes.path}
          d="M162.9,66.6c-.7,0-1.4-.2-2-.7-1-1.1-1-2.7,0-3.7s1.3-.8,2-.7c.7,0,1.4.2,2,.7.5.5.7,1.2.7,1.9s-.2,1.4-.7,1.8c-.5.5-1.3.7-2,.7ZM160.9,91.8v-20.6h4v20.7h-4Z"
        />
        <path
          className={classes.path}
          d="M179,92.2c-1.8,0-3.6-.5-5.1-1.5-1.5-.9-2.7-2.3-3.6-3.8-1.8-3.4-1.8-7.5,0-11,.8-1.6,2.1-2.9,3.6-3.8s3.3-1.4,5.1-1.4,3.4.4,5,1.1c1.4.7,2.6,1.7,3.4,3l-2.2,2.8c-.7-1-1.6-1.8-2.6-2.3-1-.6-2.1-.9-3.2-.9s-2.4.3-3.4.9-1.8,1.5-2.3,2.5c-.6,1.1-.9,2.4-.9,3.6s.3,2.5.9,3.6c.6,1,1.4,1.9,2.4,2.5s2.1,1,3.3.9c2.1,0,4.1-1,5.8-3.2l2.2,2.8c-.9,1.3-2.2,2.3-3.6,2.9-1.4.9-3.1,1.3-4.8,1.3Z"
        />
        <path
          className={classes.path}
          d="M197.3,92.2c-1.6,0-3.2-.3-4.7-.9-1.4-.6-2.6-1.5-3.5-2.7l2.8-2.4c.7.9,1.6,1.5,2.6,2,1,.4,2.1.6,3.2.6s1.7-.2,2.4-.7c.6-.5.9-1.2.9-1.9s-.3-1.2-.7-1.7c-1.1-.6-2.2-1.1-3.4-1.3-1.3-.3-2.5-.8-3.7-1.3-.9-.4-1.6-1-2.2-1.7-.8-1-1.2-2.3-1.1-3.6,0-1.1.3-2.2,1-3.1s1.6-1.6,2.7-2.1c1.2-.5,2.5-.8,3.8-.8s2.9.3,4.3.9c1.3.5,2.4,1.4,3.3,2.4l-2.3,2.5c-.7-.8-1.6-1.4-2.6-1.8-.8-.4-1.7-.7-2.5-.7s-1.8.2-2.6.6c-.6.4-1,1.1-.9,1.8,0,.7.3,1.3.9,1.7,1.1.7,2.3,1.1,3.5,1.3,1.1.3,2.2.7,3.2,1.1.7.3,1.4.8,2,1.4.5.5.9,1.1,1.1,1.7.2.7.3,1.5.3,2.2,0,1.1-.3,2.2-1,3.2s-1.6,1.7-2.7,2.2c-1.5.9-2.8,1.1-4.1,1.1Z"
        />
        <g>
          <rect
            className={classes.path}
            x="186.2"
            y="150.2"
            width="16.2"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
          <rect
            className={classes.path}
            x="186.2"
            y="140.4"
            width="16.2"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
          <rect
            className={classes.path}
            x="205.7"
            y="140.4"
            width="16.2"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
          <rect
            className={classes.path}
            x="205.7"
            y="130.7"
            width="16.2"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
          <rect
            className={classes.path}
            x="225.2"
            y="140.4"
            width="16.2"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
          <rect
            className={classes.path}
            x="225.2"
            y="130.7"
            width="16.2"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
          <rect
            className={classes.path}
            x="244.6"
            y="140.4"
            width="16.2"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
          <rect
            className={classes.path}
            x="244.6"
            y="130.7"
            width="16.2"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
          <rect
            className={classes.path}
            x="264.1"
            y="140.4"
            width="16.2"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
          <rect
            className={classes.path}
            x="264.1"
            y="130.7"
            width="16.2"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
          <rect
            className={classes.path}
            x="225.2"
            y="121"
            width="16.2"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
          <rect
            className={classes.path}
            x="225.2"
            y="111.2"
            width="16.2"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
          <rect
            className={classes.path}
            x="244.6"
            y="121"
            width="16.2"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
          <rect
            className={classes.path}
            x="244.6"
            y="111.2"
            width="16.2"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
          <rect
            className={classes.path}
            x="264.1"
            y="121"
            width="16.2"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
          <rect
            className={classes.path}
            x="264.1"
            y="111.2"
            width="16.2"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
          <rect
            className={classes.path}
            x="225.2"
            y="101.5"
            width="16.2"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
          <rect
            className={classes.path}
            x="225.2"
            y="91.8"
            width="16.2"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
          <rect
            className={classes.path}
            x="244.6"
            y="101.5"
            width="16.2"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
          <rect
            className={classes.path}
            x="244.6"
            y="91.8"
            width="16.2"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
          <rect
            className={classes.path}
            x="264.1"
            y="101.5"
            width="16.2"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
          <rect
            className={classes.path}
            x="264.1"
            y="91.8"
            width="6.5"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
          <rect
            className={classes.path}
            x="215.4"
            y="91.8"
            width="6.5"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
          <rect
            className={classes.path}
            x="215.4"
            y="101.5"
            width="6.5"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
          <rect
            className={classes.path}
            x="215.4"
            y="111.2"
            width="6.5"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
          <rect
            className={classes.path}
            x="283.6"
            y="101.5"
            width="6.5"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
          <rect
            className={classes.path}
            x="283.6"
            y="111.2"
            width="6.5"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
          <rect
            className={classes.path}
            x="283.6"
            y="130.7"
            width="6.5"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
          <rect
            className={classes.path}
            x="196"
            y="130.7"
            width="6.5"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
          <rect
            className={classes.path}
            x="176.5"
            y="150.2"
            width="6.5"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
          <rect
            className={classes.path}
            x="234.9"
            y="150.2"
            width="6.5"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
          <rect
            className={classes.path}
            x="225.2"
            y="82"
            width="16.2"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
          <rect
            className={classes.path}
            x="225.2"
            y="72.3"
            width="16.2"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
          <rect
            className={classes.path}
            x="244.6"
            y="82"
            width="16.2"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
          <rect
            className={classes.path}
            x="225.2"
            y="62.6"
            width="16.2"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
          <rect
            className={classes.path}
            x="244.6"
            y="62.6"
            width="16.2"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
          <rect
            className={classes.path}
            x="225.2"
            y="52.8"
            width="16.2"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
          <rect
            className={classes.path}
            x="225.2"
            y="43.1"
            width="16.2"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
          <rect
            className={classes.path}
            x="234.9"
            y="33.4"
            width="6.5"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
          <rect
            className={classes.path}
            x="244.6"
            y="33.4"
            width="6.5"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
          <rect
            className={classes.path}
            x="244.6"
            y="43.1"
            width="6.5"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
          <rect
            className={classes.path}
            x="215.4"
            y="43.1"
            width="6.5"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
          <rect
            className={classes.path}
            x="215.4"
            y="52.8"
            width="6.5"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
          <rect
            className={classes.path}
            x="234.9"
            y="23.6"
            width="6.5"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
          <rect
            className={classes.path}
            x="244.6"
            y="52.8"
            width="16.2"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
          <rect
            className={classes.path}
            x="244.6"
            y="72.3"
            width="16.2"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
          <rect
            className={classes.path}
            x="264.1"
            y="82"
            width="6.5"
            height="6.5"
            rx="3.2"
            ry="3.2"
          />
        </g>
      </svg>

      <span className={classes.text}>TechDocs</span>
    </span>
  );
};

export default LogoFull;
